if (!customElements.get('shopify-authenticate')) {
  customElements.define(
    'shopify-authenticate',
    class ShopifyAuthenticate extends HTMLElement {
      constructor() {
        super();

        this.loginHeader = this.querySelector('#login');
        this.recoverHeader = this.querySelector('#recover');
        this.loginBody = this.querySelector('#loginBody');
        this.recoverBody = this.querySelector('#recoverBody');
        this.loginImage = this.querySelector('#loginImage');
        this.recoverImage = this.querySelector('#recoverImage');

        this.loginTrigger = this.querySelector('authenticate-login');
        this.recoverTrigger = this.querySelector('authenticate-recover');

        if (this.loginTrigger) {
          this.loginTrigger.addEventListener('click', this.showLogin.bind(this));
        }

        if (this.recoverTrigger) {
          this.recoverTrigger.addEventListener('click', this.showRecover.bind(this));
        }

        if (this.loginTrigger && this.recoverTrigger) {
          if (window.location.hash == '#recover') {
            this.showRecover(new Event('click'));
          } else {
            this.showLogin(new Event('click'));
          }
        }
      }

      showLogin(e) {
        e.preventDefault();

        this.loginHeader.classList.remove('hidden');
        this.recoverHeader.classList.add('hidden');

        this.loginBody.classList.remove('hidden');
        this.recoverBody.classList.add('hidden');

        this.loginImage.classList.remove('hidden');
        this.recoverImage.classList.add('hidden');
      }

      showRecover(e) {
        e.preventDefault();

        this.loginHeader.classList.add('hidden');
        this.recoverHeader.classList.remove('hidden');

        this.loginBody.classList.add('hidden');
        this.recoverBody.classList.remove('hidden');

        this.loginImage.classList.add('hidden');
        this.recoverImage.classList.remove('hidden');
      }
    }
  );
}
